import React from "react";
import { Truck, Tag } from "lucide-react";

// "Add 5 more copies to get free delivery."
//
// Shown wherever a buyer is choosing a quantity — the cart and the product
// page — because that is the moment the prompt is useful. Both offers are
// listed when both are still out of reach: someone at 25 copies is close to
// free delivery and a long way from the bulk price, and seeing only the nearer
// one hides the bigger saving.
//
// Takes a priced quote rather than fetching anything itself, so the two callers
// cannot drift apart in wording.

function Line({ icon: Icon, remaining, what, detail, testId }) {
  return (
    <div className="flex items-start gap-2.5" data-testid={testId}>
      <Icon className="w-4 h-4 text-[#946f36] shrink-0 mt-0.5" strokeWidth={1.5} />
      <span>
        Add <strong>{remaining}</strong> more {remaining === 1 ? "copy" : "copies"} to
        get {what}.
        {detail ? <span className="text-[#946f36]"> {detail}</span> : null}
      </span>
    </div>
  );
}

export default function BulkNudge({ quote, className = "", testId = "bulk-nudge" }) {
  if (!quote) return null;

  const delivery = quote.nextFreeDelivery;
  const discount = quote.nextDiscount;
  const showDelivery = delivery && delivery.remaining > 0;
  const showDiscount = discount && discount.remaining > 0;
  if (!showDelivery && !showDiscount) return null;

  return (
    <div
      data-testid={testId}
      className={`border border-[#946f36]/40 bg-[#FDFBF7] p-3.5 text-xs text-[#4A3728] leading-relaxed space-y-2 ${className}`}
    >
      {showDelivery && (
        <Line
          icon={Truck}
          remaining={delivery.remaining}
          what="free delivery"
          detail={delivery.label}
          testId={`${testId}-delivery`}
        />
      )}
      {showDiscount && (
        <Line
          icon={Tag}
          remaining={discount.remaining}
          what="the discounted price"
          detail={discount.label}
          testId={`${testId}-discount`}
        />
      )}
    </div>
  );
}
